import { Helmet } from "react-helmet"
import { i18n } from "@lingui/core"
import { t } from "@lingui/macro"
import { useStoreState } from "./providers/StoreProvider"

export function AppHead() {
  const locale = i18n.locale
  const ogLocale = locale.replace("-", "_")
  const countryCode = locale.split("-")[1]

  const { footer, email, logoHeader } = useStoreState()[0].config

  const logoImgParsed = (() => {
    try {
      return logoHeader.img ? JSON.parse(logoHeader.img) : undefined
    } catch {
      return undefined
    }
  })()
  const logoUrl =
    logoHeader.type === "I" && logoImgParsed ? logoImgParsed.large : undefined

  const sameAs = footer.socials.map(s => s.url).filter(Boolean)

  const organizationSchema: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: window.STORE_NAME,
    url: window.location.origin,
    inLanguage: locale,
    areaServed: countryCode,
    ...(logoUrl && { logo: logoUrl }),
    ...(sameAs.length > 0 && { sameAs }),
    ...(email && { email }),
    ...(footer.phoneNumber &&
      footer.showContact && {
        contactPoint: {
          "@type": "ContactPoint",
          telephone: footer.phoneNumber,
          contactType: "customer service",
        },
      }),
  }

  const description = t`Comprá online en ${window.STORE_NAME}. Encontrá los mejores productos con envío y múltiples medios de pago.`

  return (
    <Helmet>
      <html lang={locale} />
      <title>{window.STORE_NAME}</title>
      <meta name="description" content={description} />
      <meta property="og:site_name" content={window.STORE_NAME} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={window.STORE_NAME} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={window.location.href.split("?")[0]} />
      <meta property="og:locale" content={ogLocale} />
      {logoUrl && <meta property="og:image" content={logoUrl} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={window.STORE_NAME} />
      <meta name="twitter:description" content={description} />
      {logoUrl && <meta name="twitter:image" content={logoUrl} />}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
    </Helmet>
  )
}
